import ReactModal from 'react-modal'
import React, { useState } from "react";
import styled from "styled-components";
import { P } from '../CommonStyle';
import "./Ces.css"
import Tick from "./images/tick.svg";
import BgR from "./images/popupBg.png";
import TickG from "./images/greenTick.svg"
import { userTrack } from '../Common';

const PopupWrap = styled.div`
  position: relative;
  min-height: 200px;
  background: #fff;
  margin: 0 auto;
  height: auto !important;
  overflow: hidden !important;
  border-radius: 11px;
  border: none;
  outline: none;
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 767px) {
    width: auto !important;
    padding: 0 15px;
    display: initial;
  }
`;


const BannerLeft = styled.div`
    background-image: url(${BgR});
    background-size: cover;
    background-repeat: no-repeat;
    height: 590px;

    @media screen and (max-width: 767px){
        display: none;
    }
`
const ContentRWrap = styled.div`
    padding: 0 60px;
    padding-top: 20px;
`
const ListWrap = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 7px;
    margin-top: 35px;
`
const TickImg = styled.img`
    margin-top: 8px;
`
const ListContent = styled.div`
    color: #FFF;
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0.4px;
`
const GTickImg = styled.img`

`
const DwnldBtn = styled.div`
    background-color: #FF7624;
    border-radius: 10px;
    padding: 11px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 13px;
    width: 85px;
    margin: 0 auto;
    cursor: pointer;

    &:hover{
        background-color: #cd5900;
    }

    @media screen and (max-width: 767px){
        width: 240px;
    }
`
const DwnldBtnTxt = styled.p`
    margin: 0;
    color: #FFF;
    font-family: Roboto;
    font-size: 17px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;

    @media screen and (max-width: 767px){
        font-size: 16px;
    }
`
const BannerRight = styled.div`
    padding: 50px 60px;
    text-align: center;
    padding-top: 15px;

    @media screen and (max-width: 767px){
        padding: 0px 20px;
    }
`
const ButtonWrapDwn = styled.div`
    margin-top: 70px;
    margin-bottom: 60px;

    @media screen and (max-width: 767px){
        margin-top: 60px;
    }
`

export default function ThankyouSubscribeReport(props) {
    const [isOpen, setIsOpen] = useState(true);
    const more = () => {
        userTrack(`${localStorage.storedEmail}`, `Clicked on " Got it`, "2024 download Form - Popup")
        props.setLook(false);
        props.loop(false);
        props.shown(false);
    }

    return (
        <div>
            <ReactModal
                isOpen={isOpen}
                onRequestClose={() => handleClose()}
                ariaHideApp={false}
                className="modal-popup-SubPopUp"
            >
                <PopupWrap>
                    <div>
                        <BannerLeft>
                            <ContentRWrap>
                                <P text="Ideapoke CES 2025" color="#fff" fontSize="32px" fontWeight="700" letterSpacing="0.4px"></P>
                                <P text="Trends & Innovations Report" color="#fff" fontSize="24px" fontWeight="700" letterSpacing="0.4px"></P>
                                <div>
                                    <ListWrap>
                                        <TickImg src={Tick}></TickImg>
                                        <ListContent>Get hints on emerging business opportunities you may be missing</ListContent>
                                    </ListWrap>
                                    <ListWrap>
                                        <TickImg src={Tick}></TickImg>
                                        <ListContent>Understand Impact of Disrupting Technologies </ListContent>
                                    </ListWrap>
                                    <ListWrap>
                                        <TickImg src={Tick}></TickImg>
                                        <ListContent>Identify Market Shifts early on</ListContent>
                                    </ListWrap>
                                    <ListWrap>
                                        <TickImg src={Tick}></TickImg>
                                        <ListContent>Spot potential partners, customers, investment opportunities</ListContent>
                                    </ListWrap>
                                </div>
                            </ContentRWrap>
                        </BannerLeft>
                    </div>
                    <div style={{ position: "relative" }}>
                        <div className="closePopup mg-0" onClick={more}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.01689 1.01689C1.34785 0.685932 1.79673 0.5 2.26478 0.5C2.73283 0.5 3.18171 0.685932 3.51267 1.01689L11 8.50422L18.4873 1.01689C18.8183 0.685932 19.2672 0.5 19.7352 0.5C20.2033 0.5 20.6521 0.685932 20.9831 1.01689C21.3141 1.34785 21.5 1.79673 21.5 2.26478C21.5 2.73283 21.3141 3.18171 20.9831 3.51267L13.4958 11L20.9831 18.4873C21.3141 18.8183 21.5 19.2672 21.5 19.7352C21.5 20.2033 21.3141 20.6521 20.9831 20.9831C20.6521 21.3141 20.2033 21.5 19.7352 21.5C19.2672 21.5 18.8183 21.3141 18.4873 20.9831L11 13.4958L3.51267 20.9831C3.18171 21.3141 2.73283 21.5 2.26478 21.5C1.79673 21.5 1.34785 21.3141 1.01689 20.9831C0.685931 20.6521 0.5 20.2033 0.5 19.7352C0.5 19.2672 0.685931 18.8183 1.01689 18.4873L8.50422 11L1.01689 3.51267C0.685931 3.18171 0.5 2.73283 0.5 2.26478C0.5 1.79673 0.685931 1.34785 1.01689 1.01689Z" fill="#676767" />
                            </svg>
                        </div>
                        <BannerRight>
                            <GTickImg src={TickG}></GTickImg>
                            <P text="Thank you for subscribing to the Ideapoke CES 2025 report." textAlign="left" color="#454545" fontSize="20px" fontWeight="600" mobFontSize="18px" MobtextAlign="center"></P>
                            <P text="You will receive it in your inbox once available in Jan 2025." textAlign="left" color="#454545" fontSize="20px" fontWeight="600" mobFontSize="18px" MobtextAlign="center" marginTop="40px"></P>

                            <ButtonWrapDwn onClick={more}>
                                <DwnldBtn>
                                    <DwnldBtnTxt>Got it! </DwnldBtnTxt>
                                </DwnldBtn>
                            </ButtonWrapDwn>
                        </BannerRight>
                    </div>
                </PopupWrap>
            </ReactModal>
        </div>
    )
}
